import type { Options as KyOptions } from 'ky'
import { ref } from 'vue'
import { serialize } from 'object-to-formdata'
import kyLib from 'ky'
import { destroySession } from './user-session'

export interface ApiInstanceOptions {
  /** Default value for loading state */
  loadingDefault?: boolean
}

export const useApi = (
  instanceOptions: ApiInstanceOptions = {},
  kyOptions: KyOptions = {},
) => {
  instanceOptions = {
    loadingDefault: false,
    ...instanceOptions,
  }

  /** Is the request loading? */
  const loading = ref<boolean>(instanceOptions.loadingDefault === true)

  const ky = kyLib.create({
    prefixUrl: import.meta.env.VITE_API_ROOT,
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'include',
    ...(kyOptions ?? {}),
    headers: {
      Accept: 'application/json',
      ...(kyOptions.headers ?? {}),
    },
    retry: 0,
    hooks: {
      ...(kyOptions.hooks || {}),
      beforeRequest: [
        async (request, options) => {
          // Loading state
          loading.value = true

          // For POST requests, convert json to FormData
          if (request.method === 'POST' && request.json) {
            return new Request(request.url, {
              ...options,
              headers: {
                ...(options.headers || {}),
              },
              body: serialize(await request.json(), {
                allowEmptyArrays: true,
              }),
            })
          }
        },
        ...(kyOptions.hooks?.beforeRequest || []),
      ],
      afterResponse: [
        () => {
          loading.value = false
        },
        ...(kyOptions.hooks?.afterResponse || []),
      ],
      beforeError: [
        (error) => {
          if (error.response.status === 401) {
            destroySession()
          }

          return error
        },
        ...(kyOptions.hooks?.beforeError || []),
      ],
    },
  })

  return {
    loading,
    ky,
  }
}
